<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form
        (ngSubmit)="confirmDelete()"
        *ngIf="project"
        [config]="preloaderService.getLoadingConfig(loaderKey)"
        [suiIsLoading]="loaderKey"
        class="dialog-form preloader-wrapper"
        name="deleteForm"
>
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>{{ 'entity.delete.title' | translate }}</h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>
    <div class="siklu-mat-dialog-body" matDialogContent>
        <winde-alert-error></winde-alert-error>
        <p [translateParams]="{ name: project.name | gtthTextEscape }" [translate]="'project.delete.question'" class="ellipsis-span"></p>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button matDialogClose windeTransparent>
            <sui-svg-icon icon="cross"/>
            {{ 'entity.action.cancel' | translate }}
        </button>
        <button type="submit" windeRed>
            <sui-svg-icon icon="trash"/>
            {{ 'entity.action.delete' | translate }}
        </button>
    </div>
</form>
